import { useState } from "react";
import ModuleCreate from "./ModuleCreate";
import ModuleEdit from "./ModuleEdit";
import ModuleList from "./ModuleList";
import ModuleView from "./ModuleView";

const ModulePage = () => {

    const [moduleState, setModuleState] = useState("list");
    const [moduleId, setModuleId] = useState();
    const handleCreate = () => {
        setModuleState("create");
    }

    const handleEdit = (module) => {
        setModuleId(module._id);
        setModuleState("edit");
    }

    const handleView = (module) => {
        setModuleId(module._id);
        setModuleState("view");
    }

    const handleActivate = (module) => {
        setModuleState("activate");
    }

    const handleDelete = (module) => {
        setModuleState("delete");
    }

    return (
        <>
            {
                moduleState === "create" && <ModuleCreate onSuccess={() => setModuleState("list")} onCancel={() => setModuleState("list")} />
            }
            {
                moduleState === "edit" && <ModuleEdit onSuccess={() => setModuleState("list")} onCancel={() => setModuleState("list")} moduleId={moduleId} />
            }
            {
                moduleState === "view" && <ModuleView onCancel={() => setModuleState("list")} moduleId={moduleId} />
            }
            {
                moduleState === "list" && <ModuleList onCreate={handleCreate} onView={handleView} onEdit={handleEdit} handleActivate={handleActivate} handleDelete={handleDelete} />
            }
        </>
    )
}

export default ModulePage